import { useTranslation } from 'react-i18next'

interface Step {
  number: number
  titleKey: string
  descriptionKey: string
}

const steps: Step[] = [
  {
    number: 1,
    titleKey: 'landing.howItWorks.steps.step1.title',
    descriptionKey: 'landing.howItWorks.steps.step1.description',
  },
  {
    number: 2,
    titleKey: 'landing.howItWorks.steps.step2.title',
    descriptionKey: 'landing.howItWorks.steps.step2.description',
  },
  {
    number: 3,
    titleKey: 'landing.howItWorks.steps.step3.title',
    descriptionKey: 'landing.howItWorks.steps.step3.description',
  },
]

export function HowItWorks() {
  const { t } = useTranslation()

  return (
    <section className="how-it-works" id="how-it-works">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">{t('landing.howItWorks.title')}</h2>
          <p className="section-subtitle">{t('landing.howItWorks.subtitle')}</p>
        </div>
        <div className="steps-grid">
          {steps.map((step) => (
            <div key={step.number} className="step-item">
              <div className="step-number">{step.number}</div>
              <h3>{t(step.titleKey)}</h3>
              <p>{t(step.descriptionKey)}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
